import { Chip, Stack, Tooltip } from "@mui/material";
import { grey } from "@mui/material/colors";
import { NavLink } from "react-router-dom";
import { ValidationError } from "..";
import { AppRoutes } from "../../../router/routes";

export const ErrorComponent = ({ errors }: { errors: ValidationError[] }) => {
    return (
        (<Stack
            direction={"row"}
            sx={{
                p: 1,
                flexWrap: 'wrap',
                gap: 2,
                mt: 1
            }}>
            {errors.map((error, idx: number) => {
                const path = error.sequence_id?.includes("BOM") ? AppRoutes.viewBomBasicDetail(error?._id) : AppRoutes.viewMatBasicDetail(error?._id)
                return (
                    <NavLink to={path} target="_blank" key={idx}>
                        <Tooltip title={(error.errors || [])?.map(e => <><span>{e}</span><br /></>)}>
                            <Chip
                                sx={{
                                    ':hover': {
                                        bgcolor: grey[100]
                                    },
                                    cursor: "pointer",
                                    p: 1.5
                                }}
                                variant="outlined"
                                label={error.sequence_id}
                            />
                        </Tooltip>
                    </NavLink>
                )
            })}
        </Stack>)
    );
};